export default "/images/6b7fa17409dd814389aaabbb15b66966.avif";